import type { ReactNode } from "react";
import type { Room } from "@circle-react/types/Live/Room";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Toolbar } from "../Toolbar";
import { CopyLinkButton } from "./Buttons/CopyLinkButton";
import { InfoButton } from "./Buttons/InfoButton";
import { CommunityInfo } from "./CommunityInfo";
import { PublicStatusBar } from "./PublicStatusBar";
import { StatusBar } from "./StatusBar";

export interface HeaderProps {
  hidden?: boolean;
  infoButton?: ReactNode;
  isHost?: boolean;
  isPublic?: boolean;
  room: Room;
  title?: string;
}

export const Header = ({
  room,
  title = "",
  isHost = false,
  isPublic = false,
  infoButton = null,
  hidden = false,
}: HeaderProps) => (
  <Toolbar autoHide={hidden} animationDirection="down">
    <div className="flex h-8 gap-6">
      <CommunityInfo />
      <div className="flex items-center gap-2 text-zinc-300">
        <Typography.LabelSm
          weight="medium"
          color="text-current"
          leading="leading-none"
        >
          {title || room.name}
        </Typography.LabelSm>
        {infoButton ?? <InfoButton room={room} isHost={isHost} />}
        <CopyLinkButton room={room} />
      </div>
    </div>
    <div className="flex h-8 gap-2 text-[#F0F3F5]">
      {isPublic ? <PublicStatusBar room={room} /> : <StatusBar room={room} />}
    </div>
  </Toolbar>
);
